module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl3-50.b7c2a964.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl3-50.png
// module id = 3532
// module chunks = 11